import { Component, h, Method, Prop, Event, EventEmitter, Element, State } from '@stencil/core';
import CloseIcon from '../../assets/icons/close.svg';
import DownloadIcon from '../../assets/icons/download-outline.svg';
import scopedStylesheet from './banner-slotted.css';
import { addSlottedStyles } from '../../utils/utils';

/**
 * @slot title - Slot for the title, must be a heading element
 * @slot body-desktop - Slot for the body content on desktop screen sizes, can be one or multiple <p> elements
 * @slot body-mobile - Slot for the body content on mobile screen sizes, can be one or multiple <p> elements
 * @slot cta-desktop - Slot for the link to be rendered on desktop, must be a valid <a> tag
 * @slot cta-mobile - Slot for the link to be rendered on mobile, must be a valid <a> tag
 */

@Component({
  tag: 'app-launch-banner',
  styleUrl: 'banner.css',
  shadow: true,
})
export class Banner {
  private mediaQueryObject = window.matchMedia('(max-width: 989px)');
  private slottedLinkDesktop: HTMLElement;

  @Prop({ reflect: true, mutable: true }) open: boolean = false;

  @State() isTabletOrMobile = this.mediaQueryObject.matches;

  @Method() async dismiss() {
    this.open = false;
    this.dismissed.emit();
  }

  @Event() dismissed: EventEmitter<null>;
  @Event() ctaClicked: EventEmitter<null>;

  @Element() hostElement: HTMLElement;

  connectedCallback() {
    addSlottedStyles(this.hostElement, scopedStylesheet);
    this.mediaQueryObject.addEventListener('change', () => {
      this.isTabletOrMobile = this.mediaQueryObject.matches;
    });
    this.slottedLinkDesktop = this.hostElement.querySelector('[slot="cta-desktop"]');
  }

  render() {
    return (
      <div id="banner">
        <app-launch-icon-button
          id="close"
          size="small"
          type="secondary ghost"
          icon={CloseIcon}
          accessibleName="Nascondi il messaggio"
          onClick={() => {
            this.dismiss();
          }}
        ></app-launch-icon-button>
        <div id="content-wrapper">
          <slot name="title">Insert title here</slot>
          <div id="body">
            <slot name={`body-${this.isTabletOrMobile ? 'mobile' : 'desktop'}`}>
              Insert body text here and a <a href="javascript:void(0)">link</a>
            </slot>
          </div>
          {((this.slottedLinkDesktop && this.slottedLinkDesktop.textContent) || this.isTabletOrMobile) && (
            <app-launch-text-button
              isLink
              iconDx={DownloadIcon}
              targetBlank
              onClick={() => {
                this.ctaClicked.emit();
              }}
            >
              <slot name={this.isTabletOrMobile ? 'cta-tablet-mobile' : 'cta-desktop'}></slot>
            </app-launch-text-button>
          )}
        </div>
      </div>
    );
  }
}
